import { createContext } from "react";

const ButtonVolumetryForm = createContext({});

export default ButtonVolumetryForm;